import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isPwaBannerRoute } from "@/lib/pwa";
import usePwa from "@/hooks/usePwa";
import PwaInstallBanner from "@/components/pwa/PwaInstallBanner";
import PwaIosSheet from "@/components/pwa/PwaIosSheet";
import PwaPushSheet from "@/components/pwa/PwaPushSheet";

const PwaContext = createContext(null);

export function usePwaContext() {
  return useContext(PwaContext);
}

export default function PwaProvider({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  const onAppSurface = Boolean(user) && isPwaBannerRoute(loc.pathname);
  const pwa = usePwa({ user, onAppSurface });

  const value = useMemo(() => pwa, [pwa]);

  return (
    <PwaContext.Provider value={value}>
      <PwaInstallBanner
        visible={pwa.showBanner}
        onInstall={pwa.onInstall}
        onDismiss={pwa.onDismiss}
      />
      <PwaIosSheet open={pwa.iosOpen} onOpenChange={pwa.setIosOpen} />
      <PwaPushSheet
        open={pwa.pushOpen}
        onAllow={pwa.onAllowPush}
        onLater={pwa.onLaterPush}
      />
      {children}
    </PwaContext.Provider>
  );
}
